import { useOutsideClick } from '../../../../hooks/use-outside-click'
import { useToggle } from 'react-use'

export function useVisible(initialIsVisible: boolean = false) {
  const [isVisible, toggleVisible] = useToggle(initialIsVisible)
  const ref = useOutsideClick(toggleVisible)
  return { ref, isVisible, toggleVisible }
}
